import React from "react";
import { FaCircleCheck } from "react-icons/fa6";
import Tooltip from "./Tooltip.jsx";
import Loader from "./Loader.jsx";
import { formatValue } from "../utils/Utils.js";
import { planFeatures } from "./planFeatures.js";
import { TierTooltipContent } from "./TierTooltipContent.jsx";

const PlanCard = ({
  planType,
  price,
  tiers,
  tierPosition = "right",
  selected = false,
  onClick,
  showSelectedBadge = false,
  actionButton,
  disabled = false,
}) => {
  const plan = planFeatures[planType];
  if (!plan) return null;

  const isSelected = selected && showSelectedBadge;

  return (
    <div
      className={`border rounded-lg p-4 w-full md:w-[340px] relative transition-all ${
        disabled ? "cursor-not-allowed opacity-60" : onClick ? "cursor-pointer" : ""
      } ${
        isSelected
          ? "border-theme-button-primary border-2 shadow-lg"
          : "border-slate-200"
      }`}
      onClick={disabled ? undefined : onClick}
    >
      {plan.badge && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md bg-theme-button-primary">
          {plan.badge}
        </div>
      )}
      <h2 className="font-bold text-center text-2xl my-2">{plan.name}</h2>
      <p className="text-center">{plan.description}</p>
      <div className="text-center my-4">
        Starts at
        <div className="text-2xl font-bold">
          {price === "-" ? (
            <Loader size={8} hideText />
          ) : (
            formatValue(price / 100).replace(".00", "")
          )}
        </div>
        <div className="text-sm">
          /mo/location{" "}
          {tiers && tiers.length > 0 && (
            <span className="inline-block relative top-1">
              <Tooltip size="xl" position={tierPosition}>
                <TierTooltipContent tiers={tiers} />
              </Tooltip>
            </span>
          )}
        </div>
      </div>

      <div>
        {plan.features.map((feature, index) => (
          <div key={index} className="flex gap-2 items-center my-4">
            <FaCircleCheck className="text-green-600 text-lg flex-shrink-0" />
            <span className="leading-tight">
              {feature.text}{" "}
              {feature.tooltip && (
                <span className={feature.useSpan ? "align-middle inline-block" : "inline-block"}>
                  <Tooltip
                    position={feature.tooltipPosition || "bottom"}
                    size="lg"
                    iconScale={3}
                  >
                    {feature.tooltip}
                  </Tooltip>
                </span>
              )}
            </span>
          </div>
        ))}
      </div>

      {actionButton && <div className="text-center pt-4">{actionButton}</div>}

      {isSelected && !actionButton && (
        <div className="text-center pt-4">
          <div className="inline-block px-4 py-2 bg-theme-button-primary text-white rounded-lg font-semibold">
            Selected
          </div>
        </div>
      )}
    </div>
  );
};

export default PlanCard;

